import React from "react";

const WelcomeUser = ({ userName }) => {
  return (
    <div className="alert alert-success mt30Xl" role="alert">
      Welcome, {userName || ""}!
    </div>
  );
};

export default WelcomeUser;